module.exports = __webpack_public_path__ + "media/images/logo-nhcorporate-s-715b39e6cb2fc146a4d0a540337d5e17.png";